import { EnrollmentActionType, EnrollmentAction } from '../actions/EnrollmentActions';
import { PackageMessageContent } from '../types/api/enrollmentContent/PackageMessageContent';
import { AvailablePlansDetail } from '../types/api/plans/AvailablePlansDetail';
import { Nullable } from '../types/custom/Nullable';

export interface EnrollmentState {
    insurabilityContent: {
        data: unknown,
        error: unknown,
        loading: boolean
    },
    welcomePage: {
        data: Nullable<PackageMessageContent>,
        error: unknown,
        loading: boolean
    },
    finishPage: {
        data: Nullable<PackageMessageContent>,
        error: unknown,
        loading: boolean
    },
    planSelectionPage: {
        data: Nullable<AvailablePlansDetail>,
        error: unknown,
        loading: boolean
    } 
}

const INITIAL_STATE: EnrollmentState = {
    insurabilityContent: {
        data: null,
        error: null,
        loading: false
    },
    welcomePage: {
        data: null,
        error: null,
        loading: false
    },
    finishPage: {
        data: null,
        error: null,
        loading: false
    },
    planSelectionPage: {
        data: null,
        error: null,
        loading: false
    }
};

export default function (state = INITIAL_STATE, action: EnrollmentAction): EnrollmentState {
    switch (action.type) {
        case EnrollmentActionType.FETCH_WELCOME_PAGE:
            return {
                ...state,
                welcomePage: {
                    data: null,
                    error: null,
                    loading: true
                }
            };
        case EnrollmentActionType.FETCH_WELCOME_PAGE_SUCCESS:
            return {
                ...state,
                welcomePage: {
                    data: action.payload,
                    error: null,
                    loading: false
                }
            };
        case EnrollmentActionType.FETCH_WELCOME_PAGE_FAILURE:
            return {
                ...state,
                welcomePage: {
                    data: null,
                    error: action.payload,
                    loading: false
                }
            };
            // Finish
            case EnrollmentActionType.FETCH_FINISH_PAGE:
            return {
                ...state,
                finishPage: {
                    data: null,
                    error: null,
                    loading: true
                }
            };
        case EnrollmentActionType.FETCH_FINISH_PAGE_SUCCESS:
            return {
                ...state,
                finishPage: {
                    data: action.payload,
                    error: null,
                    loading: false
                }
            };
        case EnrollmentActionType.FETCH_FINISH_PAGE_FAILURE:
            return {
                ...state,
                finishPage: {
                    data: null,
                    error: action.payload,
                    loading: false
                }
            };
        // Plans
        case EnrollmentActionType.FETCH_AVAILABLE_PLANS:
            return {
                ...state,
                planSelectionPage: {
                    data: null,
                    error: null,
                    loading: true
                }
            };
        case EnrollmentActionType.FETCH_AVAILABLE_PLANS_SUCCESS:
            return {
                ...state,
                planSelectionPage: {
                    data: action.payload,
                    error: null,
                    loading: false
                }
            };
        case EnrollmentActionType.FETCH_AVAILABLE_PLANS_FAILURE:
            return {
                ...state,
                planSelectionPage: {
                    data: null,
                    error: action.payload,
                    loading: false
                }
            };
        case EnrollmentActionType.FETCH_INSURABILITY_PAGE:
            return {
                ...state,
                insurabilityContent: {
                    data: null,
                    error: null,
                    loading: true
                }
            };
        case EnrollmentActionType.FETCH_INSURABILITY_PAGE_SUCCESS:
            return {
                ...state,
                insurabilityContent: {
                    data: action.payload,
                    error: null,
                    loading: false
                }
            };
        case EnrollmentActionType.FETCH_INSURABILITY_PAGE_FAILURE:
            return {
                ...state,
                insurabilityContent: {
                    error: action.payload,
                    data: null,
                    loading: false
                }
            };
        default:
            return state;
    }
}